import React from "react";


const Card2 = () => {
  return (
    <section className="container">

      <div className="row active-with-click">

        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="card">
            <div className="additional">
              <div className="user-card">
                {/* <div className="level center">
        Level 13
      </div>
      <div className="points center">
        5,312 Points
      </div> */}
                <img src="images/user-black.png" />

              </div>
              <div className="more-info">
                <h1>تخصص ها : </h1>

                <div className="coords">

                  <span>Asp.net</span>
                </div>
                <div className="stats">
                  <div>
                    <div className="title">دانشجویان</div>
                    <i className="zmdi zmdi-accounts-outline"></i>
                    <div className="value">2</div>
                  </div>
                  <div>
                    <div className="title">دوره ها</div>
                    <i className="zmdi zmdi-play-circle"></i>
                    <div className="value">27</div>
                  </div>
                  <div>
                    <div className="title">پروژه ها</div>
                    <i className="zmdi zmdi-code-smartphone"></i>
                    <div className="value">123</div>
                  </div>
                  <div>
                    <div className="title">مقالات</div>
                    <i className="zmdi zmdi-blogger"></i>
                    <div className="value infinity">23</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="general">
              <h1>مدرس 1</h1>
              <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>

            </div>
          </div>
        </div>
        {/* one */}
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="card">
            <div className="additional">
              <div className="user-card">

                <img src="images/user-black.png" />
              </div>
              <div className="more-info">
                <h1>تخصص ها :</h1>
                <div className="coords">

                  <span>Php</span>

                </div>
                <div className="coords">

                  <span>Javascript</span>

                </div>
                <div className="stats">
                  <div>
                    <div className="title">دانشجویان</div>
                    <i className="zmdi zmdi-accounts-outline"></i>
                    <div className="value">2</div>
                  </div>
                  <div>
                    <div className="title">دوره ها</div>
                    <i className="zmdi zmdi-play-circle"></i>
                    <div className="value">27</div>
                  </div>
                  <div>
                    <div className="title">پروژه ها</div>
                    <i className="zmdi zmdi-code-smartphone"></i>
                    <div className="value">123</div>
                  </div>
                  <div>
                    <div className="title">مقالات</div>
                    <i className="zmdi zmdi-blogger"></i>
                    <div className="value infinity">20</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="general">
              <h1>مدرس 2</h1>
              <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>

            </div>
          </div>
        </div>
        {/* two */}
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="card">
            <div className="additional">
              <div className="user-card">

                <img src="images/user-black.png" />
              </div>
              <div className="more-info">
                <h1>تخصص ها :</h1>
                <div className="coords">

                  <span>Asp.net</span>
                </div>
                <div className="coords">

                  <span>Javascript</span>

                </div>
                <div className="stats">
                  <div>
                    <div className="title">دانشجویان</div>
                    <i className="zmdi zmdi-accounts-outline"></i>
                    <div className="value">2</div>
                  </div>
                  <div>
                    <div className="title">دوره ها</div>
                    <i className="zmdi zmdi-play-circle"></i>
                    <div className="value">27</div>
                  </div>
                  <div>
                    <div className="title">پروژه ها</div>
                    <i className="zmdi zmdi-code-smartphone"></i>
                    <div className="value">123</div>
                  </div>
                  <div>
                    <div className="title">مقالات</div>
                    <i className="zmdi zmdi-blogger"></i>
                    <div className="value infinity">20</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="general">
              <h1>مدرس 3</h1>
              <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>

            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="card">
            <div className="additional">
              <div className="user-card">

                <img src="images/user-black.png" />
              </div>
              <div className="more-info">
                <h1>تخصص ها :</h1>
                <div className="coords">
                  <span>React.js</span>
                </div>

                <div className="stats">
                  <div>
                    <div className="title">دانشجویان</div>
                    <i className="zmdi zmdi-accounts-outline"></i>
                    <div className="value">2</div>
                  </div>
                  <div>
                    <div className="title">دوره ها</div>
                    <i className="zmdi zmdi-play-circle"></i>
                    <div className="value">27</div>
                  </div>
                  <div>
                    <div className="title">پروژه ها</div>
                    <i className="zmdi zmdi-code-smartphone"></i>
                    <div className="value">123</div>
                  </div>
                  <div>
                    <div className="title">مقالات</div>
                    <i className="zmdi zmdi-blogger"></i>
                    <div className="value infinity">20</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="general">
              <h1>مدرس 4  </h1>
              <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Card2;